// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
// ITEM QUE SE DEBE MODIFICAR PARA LOS CRUD
import {Usuario} from './../recursos/modelo/usuario';
import {UtilConfig} from "../../../../../autenticacion/servicios/UtilConfig";
import {ScrollEvent} from 'ngx-scroll-event';
import {ConsumerService} from "../../../../recursos/servicio/consumer.service";
import {WebServices} from "../../../../recursos/modelo/consumerModel/web-services.enum";
import {FormControl} from "@angular/forms";
import {Ng2DeviceService} from "ng2-device-detector";

import * as Stomp from "stompjs";
import * as SockJS from "sockjs-client";
import {saveAs} from 'file-saver/FileSaver';
import {Emisor} from "../../emisor/recursos/modelo/emisor";
import {LayoutService} from "../../../../recursos/servicio/layout.service";

declare const $: any;

declare var swal: any;

@Component({
    moduleId: module.id,
    selector: 'cmp-usuario',
    templateUrl: './view/list-usuario.component.html',
    styleUrls: ["./css/list-usuario.component.scss"],
    providers: [ConsumerService]
})
export class ListUsuarioComponent implements OnInit, OnChanges {

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─

    // ITEM DEL CRUD
    origenCRUD = "Usuario";
    // variables de pantalla
    selectedLista = true;
    search = "";
    searchField: FormControl;

    mensaje = "<i class='material-icons'>search</i>REALICE SU BUSQUEDA UTILIZANDO LOS FILTROS";
    cargandoList = false;
    noHayResultados = false;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_USUARIO_LISTAR: false,
        ROLE_USUARIO_CONSULTAR: false,
        ROLE_USUARIO_REGISTRAR: false,
        ROLE_USUARIO_MODIFICAR: false,
        ROLE_USUARIO_ELIMINAR: false,
        ROLE_USUARIO_ACTIVAR: false,
        ROLE_USER_DESCARGAR_EXCEL: false,
    };
    //variables modelo
    ItemLista: Usuario[];
    ItemSelected: Usuario;

    // scroll list
    scrollItems: Usuario[] = [];
    readonly bufferSize: number = 50;
    timer: any;
    loadingTexto: boolean = false;
    loadingTextoRefinir: boolean = false;
    totalRegistros = 0;
    usuarioSession: any;
    init = true;
    private stompClient;
    emisor: Emisor = new Emisor();

    private colorIcons = null;
    private colorTitle = null;

    constructor(private route: ActivatedRoute,
                private consumer: ConsumerService,
                private router: Router,
                private layout: LayoutService,
                private jwtUtil: UtilConfig,
                private deviceService: Ng2DeviceService) {

        this.ItemLista = [];
        this.usuarioSession = jwtUtil.getCurrentUser();
        this.emisor = jwtUtil.getCurrentUser().customer;
        // VERIFICA LOS PERMISOS DEL USUARIO LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        if (this.authorities.ROLE_USUARIO_LISTAR)
            this.route.params.subscribe(params => {
                if (params['busqueda']) {
                    this.search = params['busqueda'];
                }
                if (params['search'] === '1') {
                    this.init = false;
                    this.realizarBusqueda();
                }
            });

        if (this.jwtUtil.getColorIcons()) {
            this.colorIcons = this.jwtUtil.getColorIcons();
        }
        this.layout.getColorIcons().subscribe(colorIcons => {
            this.colorIcons = colorIcons;
        });
        if (this.jwtUtil.getColorTitle()) {
            this.colorTitle = this.jwtUtil.getColorTitle();
        }
        this.layout.getColorTitle().subscribe(colorTitle => {
            this.colorTitle = colorTitle;
        });
    }

    public handleScroll(event: ScrollEvent) {

        if (event.isReachingBottom) {
            this.fetchMore(event);
        }
        if (event.isWindowEvent) {
            this.fetchMore(event);
        }

    }

    fetchMore(event) {
        if (this.scrollItems.length != this.ItemLista.length) {
            this.loadingTexto = true;
            this.fetchNextChunk(this.scrollItems.length, this.bufferSize, event).then(chunk => {
                this.scrollItems = this.scrollItems.concat(chunk);
                this.loadingTexto = false;
            }, () => this.loadingTexto = false);
        } else {
            this.loadingTexto = false;
            this.loadingTextoRefinir = true;
        }
    }

    fetchNextChunk(skip: number, limit: number, event?: any): Promise<Usuario[]> {
        return new Promise((resolve, reject) => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if (skip < this.ItemLista.length) {
                    return resolve(this.ItemLista.slice(skip, skip + limit));
                }
                reject();
            }, 1000 + Math.random() * 1000);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        this.reset();
    }

    reset() {
        this.fetchNextChunk(0, this.bufferSize, {}).then(chunk => {
            this.scrollItems = chunk;
            this.cargandoList = false;
        });
    }

    ngOnInit() {

        if (this.deviceService.isMobile() || this.deviceService.isTablet())
            this.selectedLista = false;

        this.searchField = new FormControl();

        this.stompConnect();
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴       


    eliminar(item) {
        swal({
            title: '¿Está seguro que desea inactivar al usuario? ',
            text: "El usuario: " + item.nombres + ", " + item.apellidos,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Inactivarlo!'
        }).then(() => {
            this.eliminarItem(item);
        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
            }
        })
    }

    activar(item) {
        swal({
            title: '¿Está seguro que desea activar al usuario? ',
            text: "El usuario: " + item.nombres + ", " + item.apellidos,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, activarlo!'
        }).then(() => {
            this.activarItem(item);

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
            }
        })
    }


    listar() {
        let filtro: any = {};
        if (this.search != "")
            filtro.busqueda = this.search;

        filtro.search = '1';
        this.router.navigate(['/content', {outlets: {'second': ['usuario', filtro]}}]);
    }

    ejecutarExportar() {
        const params = {
            ids: this.obtenerIdSelection().toString(),
            customerType: this.emisor.type,
            formato: 'EXCEL',
            reporte: {
                id: 7,
                nombre: 'Exportación de documentos enviados',
                fileName: 'exportUsers',
                urlJasper: 'exports/exportUsers.jasper'
            }
        };
        this.cargandoList = true;
        this.consumer.post<any>(WebServices.URL_GET_USER_EXPORTAR, params)
            .subscribe(result => {
                const document: any = result['documents'];
                fetch('data:application/xlsx;base64,' + document)
                    .then((resp) => {
                        return resp.blob();
                    })
                    .then((blob) => {
                        saveAs(blob, 'exportMasivoUsuarios.xlsx');
                    });
                this.cargandoList = false;
            }, err => {
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, 'No se pudo exportar el documento de usuarios', this.router);
            });

    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐ 
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘ 

    obtenerIdSelection() {
        return this.ItemLista.map((task) => task.id);
    }

    eliminarItem(item) {
        // LLAMADO AL SERVICIO
        this.cargandoList = true;
        this.consumer.delete<any>(WebServices.URL_INACTIVAR_USUARIO, {usuario: {id: item.id}})
            .subscribe((result) => {
                swal(
                    'Usuario inactivado!',
                    'Usuario inactivadado satisfactoriamente.',
                    'success'
                );
                item.logEstatusRegistro = "INACTIVO";
                this.cargandoList = false;
            }, err => {
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo inactivar el usuario", this.router)
            });
    }

    activarItem(item) {
        // LLAMADO AL SERVICIO
        this.cargandoList = true;
        this.consumer.activar<any>(WebServices.URL_ACTIVAR_USUARIO, {usuario: {id: item.id}})
            .subscribe((result) => {
                swal(
                    'Usuario activado!',
                    'Usuario activado satisfactoriamente!',
                    'success'
                );
                item.logEstatusRegistro = "ACTIVO";
                this.cargandoList = false;
            }, err => {
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo activar el usuario", this.router)
            });
    }

    stompConnect() {
        let socket = new SockJS(this.jwtUtil.URL_WS_BACKEND + '/realTime');
        this.stompClient = Stomp.over(socket);
        this.stompClient.debug = null;
        this.stompClient.connect({}, (frame) => {
            this.stompClient.subscribe('/topicUser', (user) => {
                let usuario = JSON.parse(user.body);
                $.each(this.scrollItems, (pos, item) => {
                    if (usuario.id == item.id) {
                        item.apellidos = usuario.apellidos;
                        item.nombres = usuario.nombres;
                        item.customer = usuario.customer;
                        item.correo = usuario.correo;
                        item.rol = usuario.rol;
                        item.logEstatusRegistro = usuario.logEstatusRegistro;
                    }
                });
                $.each(this.ItemLista, (pos, item) => {
                    if (usuario.id == item.id) {
                        item.apellidos = usuario.apellidos;
                        item.nombres = usuario.nombres;
                        item.customer = usuario.customer;
                        item.correo = usuario.correo;
                        item.rol = usuario.rol;
                        item.logEstatusRegistro = usuario.logEstatusRegistro;
                    }
                });
            });
        });
    }

    stompDisconnect() {
        if (this.stompClient !== null) {
            this.stompClient.disconnect();
        }
    }

    private realizarBusqueda() {
        // LLAMADO AL SERVICIO

        this.cargandoList = true;
        this.consumer.search<any>(this.search, null, WebServices.URL_LIST_USUARIO)
            .subscribe((result) => {
                this.ItemLista = (<Array<Usuario>>result["usuarios"]);
                if (this.ItemLista.length == 0) {
                    this.mensaje = "<i class='material-icons'>youtube_searched_for</i> UTILICE OTRO FILTRO DE BÚSQUEDA SOBRE <b>" + this.origenCRUD.toUpperCase() + "S </b>. NO SE HAN ENCONTRADO REGISTROS";
                }

                this.totalRegistros = result["rowsCount"];
                if (this.totalRegistros == 0) {
                    this.cargandoList = false;
                } else {
                    // Internamente este método llama a this.cargandoList = false;

                    this.reset();
                }

            }, err => {

                this.ItemLista = [];
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo listar las " + this.origenCRUD.toLowerCase() + "s", this.router)
            });
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/usuario/cmp-list-usuario/list-usuario.component.ts